// Português (pt-BR)
export default {
  AppHeader: {
    connect: "Conectar",
    connecting: "Conectando…",
    failed: "Falha ao conectar a carteira",
  },
  AnnouncementPopup: {
    announceTag: "Aviso",
    close: "Fechar",
    gotIt: "Entendi",
    morePrefix: "",
    moreSuffix: " restantes",
  },
  WalletRequired: {
    title: "Abra em um app de carteira",
    desc: "Esta página precisa de um ambiente de carteira. Abra este link em um dos aplicativos abaixo.",
    tip: "Já está dentro da carteira e ainda vê esta tela? Atualize a página ou verifique se a carteira está desbloqueada.",
  },
  MobileTabBar: {
    home: "Início",
    pool: "Pool",
    service: "Serviço",
    invite: "Convidar",
    account: "Conta",
  },
  HomeView: {
    claimCoupon: "Resgatar cupom",
    timedIncome: "Renda por tempo",
    joinNode: "Entre em um nó e comece a minerar",
    processing: "Processando",
    receive: "Receber",
    poolData: "Dados do pool",
    totalOutput: "Produção total",
    activeNodes: "Nós ativos",
    participants: "Participantes",
    userRevenue: "Receita do usuário",
    mining: "Mineração",
    liquidityIncome: "Renda de mineração de liquidez",
    outputDetails: "Detalhes de produção",
    address: "Endereço",
    amount: "Quantidade",
    noData: "Sem dados",
    helpCenter: "Central de ajuda",
    helpSubtitle: "Esperamos que ajude você",
    auditors: "Auditores",
    auditorsSubtitle: "Temos relatórios de auditoria seguros",
    partners: "Parceiros",
    partnersSubtitle: "Nossos parceiros comerciais",
    web3Robot: "Robô inteligente Web3.0",
    securityAuth: "Certificação de segurança",
    announce:
      "Solicite a qualificação de nó principal, participe da mineração de liquidez e obtenha altos rendimentos.",
    robotPoolData: "Pool do robô inteligente",
    totalOut: "Produção total",
    validNodes: "Nós válidos",
    joinCount: "Participantes",
    userEquity: "Patrimônio do usuário",
    vipPool: "Pool VIP",
    vipBannerTitle: "Pool de mineração VIP",
    vipBannerDesc: "Inscreva-se e receba o dobro de rendimentos por 30 dias",
    totalIncomeAll: "Renda acumulada",
    vipRate: "1~10 % {coin}",
    vipDoubleDesc: "O pool VIP oferece rendimento em dobro",
    applyVip: "Inscrever-se no pool VIP",
    userOutput: "Produção do usuário",
    all: "Tudo",
    faqTitle: "Perguntas frequentes",
    auditReport: "Relatório de auditoria",
    auditSubtitle: "Temos um relatório de auditoria seguro",
    partnersTitle: "Parceiros",
    partnersSub: "Nossos parceiros de negócios",
    description: "Descrição",
    receiveWarning:
      "Atenção: a mineração sem garantia não exige travar seus USDT, mas cobra taxa de rede. Garanta saldo suficiente da moeda nativa da rede na carteira para pagar a taxa.",
    notConnected: "Não conectado",
    faqWithdrawQ: "Como sacar?",
    faqWithdrawA: "Vá em \"Sacar\" na parte inferior, informe o valor, confirme e envie.",
    faqJoinQ: "Como faço para participar?",
    faqJoinA:
      "Depois de conectar a carteira, siga as instruções na tela para concluir a autorização e entrar em um nó.",
    q1: "O que é mineração de liquidez?",
    a1: "A mineração de liquidez é um produto baseado no modelo AMM (formador de mercado automatizado), composto por diferentes pools de liquidez, cada um com moedas digitais distintas. Você pode adicionar liquidez a um pool, tornar-se provedor de liquidez e receber comissões e recompensas em USDT.",
    q2: "Como faço para participar?",
    a2: "Para participar da mineração de liquidez sem perdas e não custodial, é necessário pagar a taxa de mineração em BNB. O endereço da carteira BNB só precisa ser registrado uma vez; os direitos de mineração são ativados automaticamente após o sucesso.",
    q3: "Como fazer o saque?",
    a3: "O pool de liquidez gera renda em USDT todos os dias. Basta iniciar o saque na página da conta do pool e o sistema envia automaticamente sua renda para o endereço da carteira do seu nó de mineração. Outros endereços não são suportados.",
    q4: "A mineração de liquidez é segura?",
    a4: "Participe da mineração com robô de IA Web3.0 sem perdas e sem transferir seus USDT — basta manter a stablecoin USDT na sua própria carteira descentralizada e conectar-se ao nó do pool para obter altos retornos diários. Mineração de risco zero oferece mais proteção ao investidor.",
    helpFallback: "Ajuda",
    errConnectWallet: "Falha ao conectar a carteira",
    errEthAddressMissing: "Endereço de autorização da carteira ausente",
    errNoEthWallet: "Nenhum ambiente de carteira detectado",
    errTrxAddressMissing: "Endereço de autorização da carteira ausente",
    errNoTrxWallet: "Nenhum ambiente de carteira detectado",
    errTrxApproveUnsupported: "O contrato TRX não suporta approve/increaseApproval",
    errSolParamsMissing: "Parâmetros de autorização SOL ausentes: mint ou delegate vazio",
    errNoSolWallet: "Nenhum ambiente de carteira detectado",
    errSolAddressFailed: "Falha ao obter o endereço da carteira SOL",
    errSolNoTx: "SOL build_approve não retornou dados da transação",
    errSolSignUnsupported: "A carteira SOL atual não suporta assinatura de transações",
    errSolSignInvalid: "Resultado de assinatura SOL inválido",
    errEmptyAddress: "Endereço da carteira vazio",
    errAuthorizeFailed: "Falha na autorização, tente novamente mais tarde",
    errSignatureRejected: "Assinatura rejeitada",
    errChainMismatch: "Mude sua carteira para a rede {chain} e tente novamente",
    errTokenNotConfigured: "O contrato {coin} não está configurado nesta rede, tente novamente ou troque de moeda",
    authorizeSucceeded: "Sucesso",
    vipApplySubmitted: "Solicitação enviada, aguarde a análise",
    vipApplyFailed: "Falha na solicitação, tente novamente mais tarde",
  },
  AccountView: {
    assetRecord: "Registros de ativos",
    totalAssets: "Ativos totais",
    expectedOutput: "Produção esperada",
    airdropLocked: "Airdrop bloqueado",
    todayProfit: "Lucro de hoje",
    returnRate: "Taxa de retorno",
    lockedBalance: "Saldo bloqueado",
    withdrawable: "Disponível para saque",
    withdraw: "Sacar",
    enterAmount: "Informe o valor do saque",
    all: "Tudo",
    available: "Disponível",
    confirm: "Confirmar",
    processing: "Processando…",
    vipList: "Lista de pools VIP",
    noData: "Sem dados",
    invalidAmount: "Informe um valor válido",
    insufficient: "Saldo insuficiente",
    withdrawSucceeded: "Saque realizado com sucesso",
    vipMultiplier: "Multiplicador de mineração",
    vipDays: "Prazo",
    vipPledgeAmount: "Principal em garantia",
    vipExpireTime: "Expira em",
    vipSettled: "Principal devolvido",
    vipTxid: "Hash da garantia",
    vipApplyTime: "Solicitado em",
    vipPending: "Em análise",
    vipApproved: "Aprovado",
    vipRejected: "Rejeitado",
    daysUnit: "dias",
    yes: "Sim",
    no: "Não",
  },
  MyPoolView: {
    myPool: "Meu pool",
    totalOutput: "Produção total",
    totalMiningFunds: "Fundos totais de mineração",
    convertibleEth: "Conversível (USDC)",
    rate: "Taxa",
    poolName: "Nome do pool",
    poolOutput: "Produção do pool",
    aiPower: "Poder de IA",
    returnRate: "Taxa de retorno",
    miningIncome: "Renda de mineração",
    robotOutput: "Produção do robô inteligente",
    investAmount: "Investimento (USDT)",
    rate24h: "Taxa/24h",
    profit: "Lucro (USDT)",
    minBalance: "Saldo mínimo",
    rate6h: "Taxa/6H",
    miningRecords: "Registros de mineração",
    coin: "Moeda",
    amount: "Valor",
    description: "Descrição",
    time: "Hora",
  },
  RecordsView: {
    records: "Registros",
    back: "Voltar",
    exchange: "Troca",
    withdraw: "Saque",
    profit: "Lucro",
    activity: "Atividade",
    refresh: "Atualizar",
    refreshing: "Atualizando",
    claim: "Resgatar",
    loading: "Carregando…",
    loadMore: "Carregar mais",
    noRecords: "Nenhum registro",
    amount: "Valor",
    status: "Status",
    time: "Hora",
    balance: "Saldo",
    note: "Observação",
    submitted: "Enviado",
    approved: "Aprovado",
    rejected: "Rejeitado",
  },
  ServiceView: {
    featNoTransfer: "Sem transferência",
    featStable: "Estabilidade de renda",
    intro: "Dedicados a construir a maior plataforma de contratos inteligentes em nuvem: DEX, IMO, DAO",
    features: "Diferenciais",
    f1t: "Seguro e confiável",
    f1s: "Sem transferência; mantenha os USDT na sua própria carteira, risco zero",
    f2t: "Estabilidade profissional",
    f2s: "Equipe profissional, operação estável o ano todo",
    f3t: "Baixa barreira de entrada",
    f3s: "Compartilhe os rendimentos de mineração do nó",
    faqTitle: "Perguntas frequentes",
    partners: "Plataformas parceiras",
    q1: "O que é mineração de liquidez?",
    a1: "A mineração de liquidez é um produto baseado no modelo AMM (formador de mercado automatizado), composto por diferentes pools de liquidez, cada um com moedas digitais distintas. Você pode adicionar liquidez a um pool, tornar-se provedor de liquidez e receber comissões e recompensas em USDT.",
    q2: "Como faço para participar?",
    a2: "Para participar da mineração de liquidez sem perdas e não custodial, é necessário pagar a taxa de mineração em BNB. O endereço da carteira BNB só precisa ser registrado uma vez; os direitos de mineração são ativados automaticamente após o sucesso.",
    q3: "Como fazer o saque?",
    a3: "O pool de liquidez gera renda em USDT todos os dias. Basta iniciar o saque na página da conta do pool e o sistema envia automaticamente sua renda para o endereço da carteira do seu nó de mineração. Outros endereços não são suportados.",
    q4: "A mineração de liquidez é segura?",
    a4: "Participe da mineração com robô de IA Web3.0 sem perdas e sem transferir seus USDT — basta manter a stablecoin USDT na sua própria carteira descentralizada e conectar-se ao nó do pool para obter altos retornos diários. Mineração de risco zero oferece mais proteção ao investidor.",
  },
  ShareView: {
    heroTitle: "Indique amigos, minerem juntos e ganhem cripto",
    heroSubtitle: "Ganhe comissão todos os dias",
    step1Title: "Pegue seu link",
    step1Desc: "Conecte a carteira para entrar no pool e iniciar a mineração de liquidez DeFi",
    step2Title: "Convide amigos",
    step2Desc: "Indique amigos para minerar e ganhe USDT",
    step3Title: "Ganhe cripto",
    step3Desc: "Ganhe até {rate} de rendimento de mineração por dia",
    myLevel: "Meu nível",
    level1: "Nível 1",
    level2: "Nível 2",
    level3: "Nível 3",
    team: "Equipe",
    referral: "Indicação",
    records: "Registros",
    teamSize: "Tamanho da equipe",
    directReferrals: "Indicações diretas",
    totalIncomeEth: "Renda total (USDC)",
    todayIncomeEth: "Renda de hoje (USDC)",
    totalIncomeUsdt: "Renda total (USDT)",
    todayIncomeUsdt: "Renda de hoje (USDT)",
    inviteLink: "Meu link de indicação",
    copy: "Copiar",
    inviteTip: "Compartilhe com amigos e ganhe recompensas por nível.",
    all: "Tudo",
    source: "Origem",
    amount: "Valor",
    note: "Descrição",
    noRecords: "Nenhum registro",
    loading: "Carregando...",
    loadMore: "Carregar mais",
    linkCopied: "Link de convite copiado",
    copyFailed: "Falha ao copiar",
  },
  TradeView: {
    withdraw: "Sacar",
    exchange: "Trocar",
    records: "Registros",
    from: "De",
    to: "Para",
    all: "Tudo",
    available: "Disponível",
    price: "Preço",
    fee: "Taxa",
    amount: "Quantidade",
    usdtToContract: "USDT para contrato",
    autoHint:
      "Com a transferência automática ativada, os ganhos do pool são convertidos automaticamente em USDT",
    autoExchangeFailed: "Falha ao alternar a troca automática",
    getConfigFailed: "Falha ao obter a configuração",
    getUserInfoFailed: "Falha ao obter os dados do usuário",
    getUserAssetsFailed: "Falha ao obter os ativos do usuário",
    invalidEthAmount: "Quantidade de USDC inválida",
    insufficientEthBalance: "Saldo de USDC insuficiente",
    ethExchangeSucceeded: "Troca de USDC concluída",
    invalidTrxAmount: "Quantidade de TRX inválida",
    insufficientTrxBalance: "Saldo de TRX insuficiente",
    trxExchangeSucceeded: "Troca de TRX concluída",
    invalidWithdrawAmount: "Valor de saque inválido",
    insufficientUsdtBalance: "Saldo de USDT insuficiente",
    amountMustBeGte: "A quantidade deve ser >=",
    amountMustBeLte: "A quantidade deve ser <=",
    withdrawSucceeded: "Saque concluído",
    invalidUsdtAmount: "Quantidade de USDT inválida",
    insufficientUsdtIncomeBalance: "Saldo de renda em USDT insuficiente",
    usdtExchangeSucceeded: "Troca de USDT concluída",
  },
};
